import { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { Plus } from "lucide-react";
import { PropertyForm } from "../components/properties/PropertyForm";
import { PropertyList } from "../components/properties/PropertyList";
import { TenantsByProperty } from "../components/properties/TenantsByProperty";

export default function Properties() {
  const [items, setItems] = useState([]);
  const [tenants, setTenants] = useState([]);
  const [rooms, setRooms] = useState([]);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => Promise.all([
    api.get("/properties").then((r) => setItems(r.data)).catch(() => setItems([])),
    api.get("/tenants").then((r) => setTenants(r.data)).catch(() => setTenants([])),
    api.get("/rooms").then((r) => setRooms(r.data)).catch(() => setRooms([])),
  ]), []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="space-y-6" data-testid="properties-page">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">Manage</div>
          <h1 className="font-display text-2xl sm:text-3xl md:text-4xl font-black tracking-tighter">Properties</h1>
        </div>
        <button onClick={() => setOpen(true)} data-testid="add-property-btn"
                className="bg-blue-600 text-white px-5 py-3 hover:bg-blue-700 inline-flex items-center gap-2 self-start sm:self-auto">
          <Plus className="h-4 w-4" /> Add property
        </button>
      </div>

      {open && <PropertyForm onDone={() => { setOpen(false); load(); }} onCancel={() => setOpen(false)} />}

      <div className="bg-white border border-slate-200 overflow-x-auto">
        <PropertyList items={items} onChanged={load} />
      </div>

      {items.length > 0 && <TenantsByProperty items={items} tenants={tenants} rooms={rooms} />}
    </div>
  );
}
